import { ImageCarousel } from '@shared-components/ImageCarousel/ImageCarousel';

import { DEFAULT_IMG_OBJ } from '../Gallery.constants';
import { SlideshowGalleryProps } from '../Gallery.entity';

import styles from './SlideshowGallery.module.css';

const SlideshowGallery = ({
  images,
  slideshowGalleryStrings,
  currentClickImgIndex,
  carouselProps,
  locale,
  isZoomEnabled,
}: SlideshowGalleryProps) => {
  const totalImgs = images.length;

  return (
    <div className={styles.container} data-test-id="slideshow-gallery">
      <ImageCarousel
        strings={slideshowGalleryStrings}
        images={totalImgs ? images : [DEFAULT_IMG_OBJ]}
        positionIndex={currentClickImgIndex}
        shouldShowDotCarousel={false}
        index={0}
        size="largest"
        carouselProps={carouselProps}
        locale={locale}
        isZoomEnabled={isZoomEnabled}
      />
    </div>
  );
};

export default SlideshowGallery;
